import apiClient from './Api';
const PREFIX = '/importtable';

const getVehicleData = postData => {
  return apiClient({
    url: `${PREFIX}/getvehicledata`,
    method: 'POST',
    data: postData
  });
};

const getVehicleImages = postData => {
  return apiClient({
    url: `${PREFIX}/getvehicleimages`,
    method: 'POST',
    data: postData
  });
};

const downloadVehicle = params => {
  return apiClient({
    url: `${PREFIX}/downloadVehicle?${params}`,
    method: 'GET',
    responseType: 'blob'
  });
};

const mavisProcess = postData => {
  return apiClient({
    url: `${PREFIX}/mavisProcess`,
    method: 'POST',
    data: postData
  });
};

const deleteVehicle = postData => {
  return apiClient({
    url: `${PREFIX}/deleteVehicle`,
    method: 'POST',
    data: postData
  });
};

// const moveVehicle = postData => {
//   return apiClient({
//     url: `${PREFIX}/moveVehicle`,
//     method: 'POST',
//     data: postData
//   });
// };

// const renameVehicle = postData => {
//   return apiClient({
//     url: `${PREFIX}/renameVehicle`,
//     method: 'POST',
//     data: postData
//   });
// };

// const swapVin = postData => {
//   return apiClient({
//     url: `${PREFIX}/swapVin`,
//     method: 'POST',
//     data: postData
//   });
// };

// const mergeVehicle = postData => {
//   return apiClient({
//     url: `${PREFIX}/mergeVehicle`,
//     method: 'POST',
//     data: postData
//   });
// };

const flagImage = postData =>
  apiClient({
    url: `${PREFIX}/flagimage`,
    method: 'POST',
    data: postData
  });

const reviewVehicle = postData =>
  apiClient({
    url: `${PREFIX}/reviewvehicle`,
    method: 'POST',
    data: postData
  });

const ImportTableService = {
  getVehicleData,
  getVehicleImages,
  downloadVehicle,
  mavisProcess,
  deleteVehicle,
  // moveVehicle,
  // renameVehicle,
  // swapVin,
  // mergeVehicle,
  flagImage,
  reviewVehicle
};

export default ImportTableService;
